// Brandnavnet skal altid skrives "InvictusA" — også i tekst med STORE BOGSTAVER.
// withBrand() ombryder forekomster, så de aldrig transformeres af CSS uppercase.
export const withBrand = (text) => {
  if (!text || !text.includes("InvictusA")) return text;
  const parts = text.split("InvictusA");
  return parts.flatMap((part, i) =>
    i < parts.length - 1
      ? [part, <span key={i} className="normal-case">InvictusA</span>]
      : [part]
  );
};
